export const agdExamesProps = {
  basename: "/plataforma/agd-exames",
};
